exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".home {\n  padding-top: 40px;\n}\n.home-panel h3 {\n  margin: 10px 0 20px;\n}\n.home-header h1,\n.home-header h3 {\n  text-align: center;\n  color: #f5f5f5;\n}\n.home-header h1 {\n  margin-bottom: 15px;\n}\n.home-header h3 {\n  margin-bottom: 30px;\n}\n.home-inner {\n  margin: 0 auto;\n  text-align: center;\n  max-width: 1280px;\n  width: 96%;\n  text-align: left;\n}\n.home-inner .list-group-item-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: normal;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader?paths=gui/css!./ui/c/home/style.styl
// module id = 883
// module chunks = 0